module.exports = "https://s81616.cdn.ngenix.net/rating-frontend/_next/static/images/cat-a96489938c8033371ce1985f22bfe7c3.png";